import { useState } from 'react';
import useAppDispatch from 'hooks/useAppDispatch';
import { getUserAction, getCompanyAction } from 'store/modules/auth/actions';
import { setCookieSessionToken } from 'utils/session';
import { CandidateService } from 'services/user.service';
import { TextField, Fab, Box, CircularProgress } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import Page from 'components/templates/Page';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { withMask } from 'utils/mask';
import { validateDocument } from 'utils/validation';

import { useStyles } from './styles';

function CreateCompany() {
  const styles = useStyles();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  const [docError, setDocError] = useState({ lastValue: '', message: '' });

  const showDocError = (currentDoc: string) => {
    if (!docError.lastValue) {
      return false;
    }
    return currentDoc === docError.lastValue;
  };

  const schema = Yup.object().shape({
    document: Yup.string()
      .required('CNPJ é um campo obrigatório.')
      .test('document', 'CNPJ inválido', (document) =>
        validateDocument({ value: document, type: 'cnpj' })
      )
  });

  const createCompany = (document: string) => {
    setLoading(true);
    CandidateService.createCompany(document)
      .then((response) => {
        const { token } = response.data;
        setCookieSessionToken(token);
        dispatch(getUserAction(token));
        dispatch(getCompanyAction(token));
      })
      .catch((err) => {
        const message = err?.response?.data?.message;
        if (
          typeof message === 'string' &&
          message.includes('CNPJ already exists')
        )
          setDocError({
            lastValue: document,
            message: 'Esse CNPJ já está cadastrado com outra conta'
          });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Page
      title="Cadastro da empresa"
      subtitle="Por favor, informe o CNPJ da sua empresa"
    >
      <Formik
        initialValues={{
          document: ''
        }}
        validationSchema={schema}
        onSubmit={(values) => createCompany(withMask(values.document, 'cnpj'))}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          touched,
          values
        }) => (
          <Form className={styles.container} onSubmit={handleSubmit}>
            <TextField
              label="CNPJ"
              value={withMask(values.document, 'cnpj')}
              error={
                (touched.document && !!errors.document) ||
                showDocError(values.document)
              }
              helperText={
                (touched.document && errors.document) ||
                (showDocError(values.document) && docError.message)
              }
              name="document"
              onBlur={handleBlur}
              onChange={handleChange}
              inputProps={{ maxLength: 18 }}
            />
            <Box className={styles.buttonContainer}>
              <Fab type="submit" disabled={loading}>
                {loading ? (
                  <CircularProgress style={{ color: '#fff' }} size={24} />
                ) : (
                  <ArrowForward />
                )}
              </Fab>
            </Box>
          </Form>
        )}
      </Formik>
    </Page>
  );
}

export default CreateCompany;
